import { OPEN_PERSON, FILTERPARAMS, FILTERPARAMS_SET, CLOSE_PERSON, GET_QUALIFICATION, GET_QUALIFICATIONTYPES, GET_MEMBERSHIP, GET_PERSONCATEGORIES, GET_NAMES, GET_FEES, GET_GROUPS } from '../actions/types'

export default function personsReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_PERSON:
      return {...state, thisperson: action.person, editedperson: action.person}
    case FILTERPARAMS:
      return {...state, filteroptions: action.filteroptions}
    case FILTERPARAMS_SET:
      return {...state, filteroptions: action.filteroptions}
    case CLOSE_PERSON:
      delete state.thisperson
      delete state.fees
      delete state.groups
      delete state.names
      return {...state}
    case GET_QUALIFICATION:
      return {...state, qualification: action.qualification}
    case GET_QUALIFICATIONTYPES:
      return {...state, qualificationtypes: action.qualificationtypes}
    case GET_MEMBERSHIP:
      return {...state, membership: action.membership}
    case GET_PERSONCATEGORIES:
      return {...state, personcategories: action.personcategories}
    case GET_NAMES:
      return {...state, names: action.names}
    case GET_FEES:
      return {...state, fees: action.fees}
    case GET_GROUPS:
      return {...state, groups: action.groups, track: action.track}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/persons_reducer.js